/**
 * Quick Add tiles in the cart drawer.
 *
 * Adds a launch flavour via /cart/add.js, then tells the theme to re-render.
 *
 * The refresh relies on the contract in assets/component-cart-items.js: on a
 * `cart:update` event whose detail carries no pre-rendered section HTML, the
 * component calls sectionRenderer.renderSection() and re-fetches the drawer
 * itself. `detail.data` must exist — the handler reads `detail.data.sections?.`
 * and would throw on an undefined `data`.
 *
 * Delegated from document because the drawer is re-rendered on every cart change,
 * which would discard listeners bound directly to the tiles.
 *
 * v2: loaded from layout/theme.liquid, NOT from the Quick Add snippet. The
 * snippet only renders inside the drawer's non-empty branch, so on a normal
 * visit (empty cart) the script tag was absent from the page entirely. Adding an
 * item then re-rendered the drawer through sectionRenderer, and a <script> tag
 * introduced that way never executes — so the handler was never bound and taps
 * did nothing. Loading it globally binds the delegated listener once, up front,
 * regardless of whether the drawer has rendered yet.
 */
(function () {
  if (window.__mimuQuickAddBound) return;
  window.__mimuQuickAddBound = true;

  var busy = false;

  function announce(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'mimu-quickadd',
          data: { source: 'mimu-quickadd' }
        }
      })
    );
  }

  function setBusy(btn, state) {
    busy = state;
    if (btn) btn.disabled = state;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-mimu-qa-add]') : null;
    if (!btn || busy) return;

    var id = parseInt(btn.getAttribute('data-mimu-qa-add'), 10);
    if (!id) return;

    event.preventDefault();
    setBusy(btn, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        announce(cart);
      })
      .catch(function () {
        // Re-enable so the shopper can retry. Deliberately silent: the drawer is
        // not a good place for an error banner, and a failed add changes nothing.
        setBusy(btn, false);
      })
      .then(function () {
        busy = false;
        // Normally the drawer re-renders and replaces this button. If it did not
        // — a failed add, or an add that changed nothing — re-enable it so the
        // tile cannot be left permanently dead.
        if (btn.isConnected) btn.disabled = false;
      });
  });
})();
